import React, { useState, useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

const API_URL = "https://backend.aktcorp.com/events";

function News() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
     /* const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("No auth token found in local storage.");
        setLoading(false);
        return;
      }*/

      const response = await axios.get(API_URL);

      setTimeout(() => {
        setEvents(response.data.data);
        setLoading(false);
      }, 500);
    } catch (error) {
      console.error("Error fetching events:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-[#0C2341]">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
          className="w-16 h-16 border-4 border-t-blue-500 border-b-transparent border-r-transparent border-l-blue-500 rounded-full"
        ></motion.div>
      </div>
    );
  }

  return (
    <div className="bg-[#0C2341] container min-h-screen md:mt-10">
      <Helmet>
        <title>AKT : Current News</title>
        <meta name="description" content="AKT Corp works with leading suppliers bringing the best materials to our clients." />
        <meta name="keywords" content="AKT Corp, Arabian Karim Trading Co., Industrial Solutions, Manufacturing Materials" />
      </Helmet>

      <h1 className="text-4xl font-bold text-center mb-10 text-gray-100">EVENTS PARTICIPATIONS</h1>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-center"
      >
        {events.map((event, index) => (
          <div key={event.id} className={`rounded-lg overflow-hidden flex flex-col items-center ${index === 1 ? "md:mt-10" : ""}`}>
            <div className={`overflow-hidden max-h-80 w-full flex justify-center items-center ${index === 1 && (!event.title?.trim() && !event.description?.trim()) ? "h-full" : ""}`}>
              <img
                src={event.image}
                alt={event.title || "Event Image"}
                className="w-full h-full object-cover rounded-lg transition-transform duration-300 hover:scale-110"
              />
            </div>

            {(event.title?.trim() || event.description?.trim()) && (
              <div className="p-3 bg-white w-full text-center">
                {event.title?.trim() && <h3 className="text-lg font-semibold">{event.title}</h3>}
                {event.description?.trim() && <p className="text-gray-600 truncate">{event.description}</p>}

                <button
                  onClick={() => setSelectedEvent(event)}
                  className="px-3 py-2 w-full mt-3 bg-white border-2 border-[#0C2340] text-[#0C2340] hover:!bg-[#1B365D] hover:text-white font-semibold rounded-lg transition duration-300"
                >
                  Read More
                </button>
              </div>
            )}
          </div>
        ))}
      </motion.div>

      {selectedEvent && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white text-black p-6 rounded-lg w-11/12 md:w-1/3 lg:w-1/3 shadow-lg relative overflow-hidden flex flex-col">
            <h2 className="text-2xl font-bold mb-4 text-center">{selectedEvent.title}</h2>
            <img
              src={selectedEvent.image}
              alt={selectedEvent.title}
              className="w-full h-64 object-cover rounded mb-4"
            />
            <div className="flex-grow p-2">
              {selectedEvent.title?.trim() && <h3 className="text-lg font-semibold">{selectedEvent.title}</h3>}
              {selectedEvent.description?.trim() && <p className="text-gray-600">{selectedEvent.description}</p>}
            </div>
            <button
              onClick={() => setSelectedEvent(null)}
              className="px-4 py-2 mt-4 bg-[#0C2340] text-white font-semibold rounded-lg w-full hover:bg-[#1B365D] transition duration-300"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-4xl font-bold text-center mb-10 text-gray-100 mt-8 md:mt-16"
      >
        BIG 5 EXHIBITION - RIYADH (KSA) 2025
      </motion.h1>
    </div>
  );
}

export default News;
